import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const ToggleContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #EEEEEE;
  border-radius: 6px;
  padding: 2px;
  font-family: 'Nunito Sans', sans-serif;
`;

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 6px 16px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.48px;
  border: none;
  border-radius: 4px;
  background: ${(props) => (props.active ? '#FFFFFF' : 'transparent')};
  color: ${(props) => (props.active ? '#444444' : '#616161')};
  cursor: pointer;
  transition: all 0.15s ease;
  position: relative;
  line-height: 1.5;
  white-space: nowrap;
  text-align: center;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    box-shadow: 0 0 0 2px rgba(93, 69, 249, 0.3);
  }

  &:hover {
    background: ${(props) => (props.active ? '#FFFFFF' : 'rgba(255, 255, 255, 0.5)')};
  }
`;

/**
 * ModeToggle Component
 *
 * Toggle between Plan and Record Notes modes.
 */
const ModeToggle = ({ mode, onModeChange, labels }) => (
  <ToggleContainer>
    <ToggleButton
      active={mode === 'plan'}
      type='button'
      aria-pressed={mode === 'plan'}
      onClick={() => onModeChange('plan')}
      title={`Switch to ${labels.plan} mode`}
    >
      {labels.plan}
    </ToggleButton>
    <ToggleButton
      active={mode === 'review'}
      type='button'
      aria-pressed={mode === 'review'}
      onClick={() => onModeChange('review')}
      title={`Switch to ${labels.review} mode`}
    >
      {labels.review}
    </ToggleButton>
  </ToggleContainer>
);

ModeToggle.propTypes = {
  mode: PropTypes.oneOf(['plan', 'review']).isRequired,
  onModeChange: PropTypes.func.isRequired,
  labels: PropTypes.shape({
    plan: PropTypes.string,
    review: PropTypes.string,
  }),
};

ModeToggle.defaultProps = {
  labels: {
    plan: 'Plan',
    review: 'Record Notes',
  },
};

export default ModeToggle;
